import apiClient from './apiClient';

// Paket 10 B10 (KAN-26 bis KAN-30): die fünf Wege der geteilten Momentaufnahmen (backend/src/routes/sharedResearch.ts).
// Liste und Einzelabruf tragen weder die Quellsitzung noch die Kennung des Einstellers; authorName ist schon der fertige
// Text (auch „Ehemaliges Mitglied“), isAuthor sagt, ob man selbst eingestellt hat, canRevoke schaltet das Zurückziehen
// (Einsteller oder wer in der Organisation Mitglieder verwaltet, members.write; F10-19), stale den Veraltungshinweis.
export interface SharedResearchItem {
  id: string;
  title: string;
  createdAt: string;
  authorName: string;
  isAuthor: boolean;
  canRevoke: boolean;
  stale: boolean;
}

// F10-26b: eine Frage oder Antwort einer Momentaufnahme der Fassung 2.
export interface SharedResearchMessage {
  rolle: 'user' | 'assistant';
  text: string;
}

// content ist immer der lesbare Text; nachrichten gibt es nur bei Momentaufnahmen der Fassung 2 (F10-26a, F10-26b).
export interface SharedResearchDetail extends SharedResearchItem {
  content: string;
  nachrichten?: SharedResearchMessage[];
}

const SHARED = '/api/ris/shared';
const one = (id: string) => `${SHARED}/${encodeURIComponent(id)}`;

// KAN-26: der Server nimmt den heutigen Stand des eigenen Verlaufs; Titel 3 bis 200 Zeichen.
async function publish(sessionId: string, title: string): Promise<{ id: string; title: string; createdAt: string }> {
  const response = await apiClient.post(`/api/ris/sessions/${encodeURIComponent(sessionId)}/publish`, { title });
  return response.data;
}

// KAN-27: die Momentaufnahmen der eigenen Organisation, neueste zuerst, höchstens 100, ohne Inhalt.
async function list(): Promise<SharedResearchItem[]> {
  const response = await apiClient.get(SHARED);
  return response.data.items;
}

async function get(id: string): Promise<SharedResearchDetail> {
  const response = await apiClient.get(one(id));
  return response.data;
}

// KAN-28: ein eigener Verlauf des Lesers; die Antwort nennt seine Kennung. F10-26b: der Stand kommt als einzelne Fragen
// und Antworten mit ihren Rollen an (ältere Momentaufnahmen als eine Nachricht mit dem ganzen Text).
async function continueFrom(id: string): Promise<string> {
  const response = await apiClient.post(`${one(id)}/continue`);
  return response.data.sessionId;
}

// KAN-29, F10-19: der Einsteller oder wer in der Organisation Mitglieder verwaltet (members.write); danach liefern Liste
// und Einzelabruf für alle 404.
async function revoke(id: string): Promise<void> {
  await apiClient.delete(one(id));
}

const sharedResearchService = { publish, list, get, continueFrom, revoke };

export default sharedResearchService;
